module.exports = __webpack_public_path__ + "img/mfl.9623b3d9.png";